export const actionTypes = {
  LOAD_SUBSCRIPTION_REPORTS_BEGIN: 'LOAD_SUBSCRIPTION_REPORTS_BEGIN',
  LOAD_SUBSCRIPTION_REPORTS_SUCCESS: 'LOAD_SUBSCRIPTION_REPORTS_SUCCESS',
  LOAD_SUBSCRIPTION_REPORTS_FAILURE: 'LOAD_SUBSCRIPTION_REPORTS_FAILURE',

  LOAD_SUBSCRIPTION_REPORTS_GET_ALL_USERS: 'LOAD_SUBSCRIPTION_REPORTS_GET_ALL_USERS',
  LOAD_SUBSCRIPTION_REPORTS_ARCHIVED: 'LOAD_SUBSCRIPTION_REPORTS_ARCHIVED',
  LOAD_SUBSCRIPTION_REPORTS_ALL_USERS_NO_RR: 'LOAD_SUBSCRIPTION_REPORTS_ALL_USERS_NO_RR',
  LOAD_SUBSCRIPTION_REPORTS_ALL_SUBSCRIPTIONS: 'LOAD_SUBSCRIPTION_REPORTS_ALL_SUBSCRIPTIONS',
  LOAD_SUBSCRIPTION_REPORTS_SUBSCRIPTIONS_DATE: 'LOAD_SUBSCRIPTION_REPORTS_SUBSCRIPTIONS_DATE',
  // date filter
  LOAD_SUBSCRIPTION_REPORTS_SUBSCRIPTIONS_BY_DATE: 'LOAD_SUBSCRIPTION_REPORTS_SUBSCRIPTIONS_BY_DATE',
  LOAD_SUBSCRIPTION_REPORTS_EXPIRED_USERS: 'LOAD_SUBSCRIPTION_REPORTS_EXPIRED_USERS',
  LOAD_SUBSCRIPTION_REPORTS_30_DAYS: 'LOAD_SUBSCRIPTION_REPORTS_30_DAYS',
  LOAD_SUBSCRIPTION_REPORTS_120_DAYS: 'LOAD_SUBSCRIPTION_REPORTS_120_DAYS',
  LOAD_SUBSCRIPTION_REPORTS_ALL_TSLIVE: 'LOAD_SUBSCRIPTION_REPORTS_ALL_TSLIVE',
  LOAD_SUBSCRIPTION_REPORTS_ALL_SPECIAL_BILLING: 'LOAD_SUBSCRIPTION_REPORTS_ALL_SPECIAL_BILLING',
  LOAD_SUBSCRIPTION_REPORTS_IRVINE_ACCOUNTS: 'LOAD_SUBSCRIPTION_REPORTS_IRVINE_ACCOUNTS',
  LOAD_SUBSCRIPTION_REPORTS_REDYREF_ACCOUNTS: 'LOAD_SUBSCRIPTION_REPORTS_REDYREF_ACCOUNTS',
  LOAD_SUBSCRIPTION_REPORTS_CANCELLED_USER: 'LOAD_SUBSCRIPTION_REPORTS_CANCELLED_USER',
  LOAD_EXPIRED_USER_REPORTS__BY_FILTER: 'LOAD_EXPIRED_USER_REPORTS__BY_FILTER',

  // Production Reports
  LOAD_PRODUCTION_REPORTS_BEGIN: 'LOAD_PRODUCTION_REPORTS_BEGIN',
  LOAD_PRODUCTION_REPORTS_SUCCESS: 'LOAD_PRODUCTION_REPORTS_SHIPPING_SUCCESS',
  LOAD_PRODUCTION_REPORTS_FAILURE: 'LOAD_PRODUCTION_REPORTS_FAILURE',
  LOAD_PRODUCTION_FILTER_SUCCESS: "LOAD_PRODUCTION_FILTER_SUCCESS",
  

  // Production Speed Reports
  LOAD_PRODUCTION_SPEED_BEGIN: 'LOAD_PRODUCTION_SPEED_BEGIN',
  LOAD_PRODUCTION_SPEED_SUCCESS: 'LOAD_PRODUCTION_SPEED_SUCCESS',
  LOAD_PRODUCTION_SPEED_FAILURE: 'LOAD_PRODUCTION_SPEED_FAILURE',
  LOAD_PRODUCTION_SPEED_DATA_BY_MONTH: 'LOAD_PRODUCTION_SPEED_DATA_BY_MONTH',
  LOAD_PRODUCTION_SPEED_FILTER_SUCCESS: 'LOAD_PRODUCTION_SPEED_FILTER_SUCCESS',


  // Enclosure PO Reports
  LOAD_ENCLOSURE_PO_ALL_BEGIN: 'LOAD_ENCLOSURE_PO_BEGIN',
  LOAD_ENCLOSURE_PO_ALL_SUCCESS: 'LOAD_ENCLOSURE_PO_SUCCESS',
  LOAD_ENCLOSURE_PO_ALL_FAILURE: 'LOAD_ENCLOSURE_PO_FAILURE',
  LOAD_ENCLOSURE_PO_COLOSIGN: 'LOAD_ENCLOSURE_PO_COLOSIGN_BEGIN',
  LOAD_ENCLOSURE_PO_KENRAY: 'LOAD_ENCLOSURE_PO_KENRAY',
  LOAD_ENCLOSURE_PO_BOYDSIGNS: 'LOAD_ENCLOSURE_PO_BOYDSIGNS',
  LOAD_ENCLOSURE_PO_TEMPORARY: 'LOAD_ENCLOSURE_PO_TEMPORARY',
  LOAD_ENCLOSURE_PO_ALLVENDORS: 'LOAD_ENCLOSURE_PO_ALLVENDORS',
  LOAD_ENCLOSURE_PO_ALLDELIVERED: 'LOAD_ENCLOSURE_PO_ALLDELIVERED',

  // All 41 project status
  LOAD_ALL41PROJECTS_BEGIN: 'LOAD_ALL41PROJECTS_BEGIN:',
  LOAD_ALL41PROJECTS_SUCCESS: 'LOAD_ALL41PROJECTS_SUCCESS',
  LOAD_ALL41PROJECTS_FAILURE: 'LOAD_ALL41PROJECTS_FAILURE',

  // Open Mods Report
  LOAD_OPEN_MODE_REPORT_BEGIN: 'LOAD_OPEN_MODE_REPORT_BEGIN:',
  LOAD_OPEN_MODE_REPORT_SUCCESS: 'LOAD_OPEN_MODE_REPORT_SUCCESS',
  LOAD_OPEN_MODE_REPORT_FAILURE: 'LOAD_OPEN_MODE_REPORT_FAILURE',

  // loading
  LOADING_BEGIN: "LOADING_BEGIN",
  LOADING_STOP: "LOADING_STOP",

  // Login
  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

  // LOGOUT
  LOGOUT_BEGIN: 'LOGOUT_BEGIN',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_FAILURE: 'LOGOUT_FAILURE',
};


// WEBPACK FOOTER //
// ./src/store/actionTypes.ts